import { ReactNode } from "react";
import LazyLoad from "react-lazyload";
import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";
import { MandatorConditional } from "@helpers";
import type { VisibilityRule } from "@helpers";

const CardWrapper = styled.div`
  width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;

  & .lazyload-wrapper {
    height: 100%;
  }
`;

const CardContent = ({ children }: { children: ReactNode }) => (
  <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
    <CardWrapper>
      <LazyLoad>{children}</LazyLoad>
    </CardWrapper>
  </Grid2>
);

export interface FundamentalsCardProps extends Partial<VisibilityRule> {
  children: ReactNode;
}

export const FundamentalsCard = ({
  children,
  hideFor,
  showFor,
}: FundamentalsCardProps) => {
  const hasVisibilityRule = hideFor !== undefined || showFor !== undefined;

  if (hasVisibilityRule) {
    return (
      <MandatorConditional hideFor={hideFor} showFor={showFor}>
        <CardContent>{children}</CardContent>
      </MandatorConditional>
    );
  }

  return <CardContent>{children}</CardContent>;
};
